<template>
  <header>
    <v-app-bar
      app
      flat
      dark
      color='#1D3557'
    >
      <v-toolbar-title>
        <v-img
          class="header-pc__logo"
          src="@/assets/coralpj_logo.png"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div
        class="px-2"
        v-for="(menuItem, index) in menuItems"
        :key="index"
      >
        <a :href="menuItem.id" class="header-pc__tab">
          {{ menuItem.name }}
        </a>
      </div>
      <a href="https://twitter.com/intent/tweet?text=東京サンゴ礁化プロジェクト&url=https://coral.innoqua.jp/" target="_blank">
        <v-img
          class="header-pc__sns"
          src="@/assets/twitter.png"

        ></v-img>
      </a>
      <a href="https://www.facebook.com/sharer/sharer.php?u=https://coral.innoqua.jp/" target="_blank">
        <v-img
          class="header-pc__sns"
          src="@/assets/facebook.png"
          target="_blank"
        ></v-img>
      </a>

    </v-app-bar>
  </header>
</template>

<script>
import constants from '../common/constants'

export default {
  name: 'HeaderPC',
  data () {
    return {
      menuItems: constants.pcMenuItems
    }
  }
}
</script>

<style lang="scss" scoped>
.header-pc__logo {
  max-width: 320px;
}
.header-pc__tab {
  font-weight: bold;
  text-decoration: none;
  color: #F1FAEE;

}
.header-pc__sns {
  margin-left: 16px;
  margin-right: 16px;
  max-width: 16px;
  fill: #F1FAEE;
}
</style>
